import React from 'react';
import View from 'components/ui/view';
import LineItem from 'components/cart/LineItem';
import { isTotalLineItem } from 'shared/models/order';

export default function OrderLineItems({ order }) {
  const lineItems = order.line_items.filter(line => !isTotalLineItem(line));

  return (
    <View padding={{ top: 'sm', bottom: 'sm' }} className="order-history-row">
      <div className="row">
        {lineItems.map(line => (
          <div key={line.title + '-' + line.display} className="col-xs-12">
            <LineItem {...line} />
          </div>
        ))}
      </div>
    </View>
  );
}
